// Country map configurations for multi-country support

export interface CountryMapConfig {
  code: string; // ISO 3166-1 alpha-2 code: 'EC', 'CO', 'PE'
  name: string; // Display name: 'Ecuador'
  geoJsonPath: string; // Path to GeoJSON file
  center: [number, number]; // Map center coordinates [lat, lng]
  zoom: number; // Default zoom level
  regionKey: string; // Key for regional divisions: 'province', 'department'
  regionLabel: string; // Display label: 'Province', 'Department'
}

export const COUNTRY_MAPS: Record<string, CountryMapConfig> = {
  EC: {
    code: 'EC',
    name: 'Ecuador',
    geoJsonPath: '/data/ecuador-provinces.json',
    center: [-1.8312, -78.1834],
    zoom: 6,
    regionKey: 'province',
    regionLabel: 'Province',
  },
  // Future countries:
  // CO: {
  //   code: 'CO',
  //   name: 'Colombia',
  //   geoJsonPath: '/data/colombia-departments.json',
  //   center: [4.5709, -74.2973],
  //   zoom: 5,
  //   regionKey: 'department',
  //   regionLabel: 'Department',
  // },
  // PE: {
  //   code: 'PE',
  //   name: 'Peru',
  //   geoJsonPath: '/data/peru-departments.json',
  //   center: [-9.19, -75.0152],
  //   zoom: 5,
  //   regionKey: 'department',
  //   regionLabel: 'Department',
  // },
};

// Default country
export const DEFAULT_COUNTRY = 'EC';

// Get country config with fallback
export const getCountryConfig = (countryCode: string): CountryMapConfig => {
  return COUNTRY_MAPS[countryCode] || COUNTRY_MAPS[DEFAULT_COUNTRY];
};

// Get all available countries
export const getAvailableCountries = (): CountryMapConfig[] => {
  return Object.values(COUNTRY_MAPS);
};
